import Vue from 'vue'
import VueRouter from 'vue-router'
import rszdyrmyy from '@/views/visualizationPage.vue'
import login from '@/views/login.vue'
Vue.use(VueRouter)
const routes = [
  {
    path: '/rzsdyrmyy',
    component: rszdyrmyy,
    beforeEnter:(to,from,next)=>{
      if (sessionStorage.getItem("name1")=="rzsdyrmyy") {
          next()
      }else{
          alert('无权查看，请先登录')
      }
  }
  },

  {
    path: '/',
    component: login,
  },
]

const router = new VueRouter({
  routes
})
export default router
